<template>
  <div :class="[$style.wrapper, hidden && $style.hidden]">
    <template v-if="state !== 'result'">
      <p :class="$style.question">Перед тобой два диалога про {{ TITLES[currentQuestion] }}. <br>Определи, какой из них принадлежит человеку,<br>а какой искусственному интеллекту?</p>
    </template>
    <transition name="scale-center">
      <div :class="$style.result" v-if="state === 'result' && isRight">
        <h1>Здорово!</h1>
        <p>Тебе удалось верно определить, <br> какой диалог кому принадлежит!</p>
        <v-btn :class="$style.button" fluid @click="next">Продолжить</v-btn>
      </div>
    </transition>
    <transition name="scale-center">
      <div :class="$style.result" v-if="state === 'result' && !isRight">
        <h1>Тебя ввели <br> в заблуждение!</h1>
        <p>{{ dialog.fail }}</p>
        <v-btn :class="$style.button" fluid @click="next">Продолжить</v-btn>
      </div>
    </transition>
    <Chars>
      <transition name="fade"><div :class="$style.pseudoCard" v-if="state !== 'question'"></div></transition>
      <transition name="fade"><div :class="$style.pseudoCard" v-if="state !== 'question'"></div></transition>
    </Chars>
    <div :class="$style.cards">
      <Card :dialog="dialog.left" class="card left" :data-man="dialog.manLeft" :inactive="state !== 'question'" :error="cardError" />
      <Card :dialog="dialog.right" class="card right" :data-man="!dialog.manLeft" :inactive="state !== 'question'" :error="cardError" delay />
    </div>
    <transition name="button-fade">
      <div v-if="state === 'check'" :class="$style.buttonWrap">
        <v-btn fluid @click="check">Проверить выбор</v-btn>
      </div>
    </transition>
    <div :class="$style.bubbles" :style="{ transform: `translateX(${-currentQuestion * (100 / COLORS.length)}%)`}">
      <Bubble
        v-for="(color, index) in COLORS"
        :key="color"
        :active="currentQuestion === index"
        :class="currentQuestion === index && $style.activeBubble"
        :color="color"
        :pin="index > currentQuestion"
        small
      >
        <template v-if="index < currentQuestion || (state === 'result' && index === currentQuestion)">
          <transition name="button-fade">
            <svg :class="$style.cross" v-if="!dialogObj[index].success" width="53" height="52" viewBox="0 0 53 52" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 5L48 47" stroke="white" stroke-width="10" stroke-linecap="round"/>
              <path d="M47 5L5 47" stroke="white" stroke-width="10" stroke-linecap="round"/>
            </svg>
            <svg v-else :class="$style.daw" width="74" height="54" viewBox="0 0 74 54" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 29L25 49" stroke="white" stroke-width="10" stroke-linecap="round"/>
              <path d="M69 5L25 49" stroke="white" stroke-width="10" stroke-linecap="round"/>
            </svg>
          </transition>
        </template>
      </Bubble>
    </div>
  </div>
</template>
<script>
import { TweenMax, Power2 } from 'gsap'
import interact from 'interactjs'
import clamp from 'lodash/clamp'

import Bubble from '@/components/@ui/Bubble/Bubble'
import Chars from '@/components/@ui/Chars/Chars'
import Card from './components/Card/Card'

import dialog from './dialog.json'

const ease = Power2.easeOut

const TITLES = [
  'дружбу',
  'мультфильмы',
  'учёбу и профессии',
  'животных',
  'мечты',
]

const COLORS = [
  'pink',
  'orange',
  'yellow',
  'green',
  'peach',
]

export default {
  name: 'Trainer',
  components: { Bubble, Card, Chars },
  data() {
    return {
      currentQuestion: 0,
      state: 'question', // question, check, result
      isRight: false,
      hidden: false,
      dialogObj: dialog,
      // dialog,
      TITLES,
      COLORS,
    }
  },
  created() {
    this.position = { x: 0, y: 0 }
    this.rotation = { x: 0, y: 0 }

    this.maxX = window.innerWidth / 2 * 0.75
    this.maxRotation = 15
    this.rotationTrigger = 6
    this.percent = 0
  },
  computed: {
    dialog() {
      const { currentQuestion } = this
      const currentDialog = dialog[currentQuestion]
      const manLeft = Math.random() > 0.5

      const { man, robot, fail } = currentDialog

      return {
        left: manLeft ? man[Math.floor(Math.random() * man.length)] : robot[Math.floor(Math.random() * robot.length)],
        right: !manLeft ? man[Math.floor(Math.random() * man.length)] : robot[Math.floor(Math.random() * robot.length)],
        obj: currentDialog,
        fail,
        manLeft,
      }
    },
    cardError() {
      return this.state === 'result' && !this.isRight
    },
  },
  methods: {
    reset(event) {
      const { position, rotationTrigger, rotation } = this

      if (Math.abs(rotation.x) >= rotationTrigger) {
        const toMan = rotation.x < 0
        const isManCard = !!event.target.dataset.man
        const isRight = isManCard ? toMan : !toMan

        const card = event.target
        const isLeft = card.classList.contains('left')
        const anotherCard = isLeft ? document.querySelector('.card.right') : document.querySelector('.card.left')

        const multi = isLeft && toMan ? 100 : 200

        TweenMax
          .to(card, 0.3, {
            x: toMan ? `-${multi}%` : `${multi}%`,
            opacity: 0,
            scale: 0.3,
          })

        TweenMax
          .to(anotherCard, 0.3, {
            x: !toMan ? `-${multi}%` : `${multi}%`,
            opacity: 0,
            scale: 0.3,
          })

        this.state = 'check'

        this.isRight = isRight

        return
      }

      position.x = 0
      position.y = 0

      TweenMax
        .to(event.target, 0.5, {
          x: 0,
          y: 0,
          rotate: 0,
          scale: 1,
          ease,
        })
    },
    resetCards() {
      TweenMax
        .to('.card.right, .card.left', 0.3, {
          opacity: 1,
          x: 0,
          y: 0,
          rotation: 0,
          scale: 1,
        })

      const { position, rotation } = this

      position.x = 0
      position.y = 0
      rotation.x = 0
      rotation.y = 0
    },
    onMove(event) {
      const {
        maxRotation, rotationTrigger, maxX,
      } = this

      this.percent = clamp(this.position.x / maxX, -1, 1)
      this.position.x += event.dx
      this.position.y += event.dy
      this.rotation.x = this.percent * maxRotation

      TweenMax
        .to(event.target, 0.3, {
          x: this.position.x,
          y: this.position.y,
          rotation: `${this.rotation.x}deg`,
          ease,
        })

      TweenMax
        .to(event.target, 0.3, {
          scale: Math.abs(this.rotation.x) >= rotationTrigger ? 1.3 : 1,
        })
    },
    initDraggable() {
      // eslint-disable-next-line no-underscore-dangle
      // interact.debug().defaultOptions._holdDuration = 300
      interact('.card').draggable({
        listeners: {
          move: this.onMove,
          end: this.reset,
        },
      })
    },
    check() {
      this.state = 'result'
      if (this.isRight) {
        this.runSuccess()
      } else {
        this.runError()
      }
    },
    hide() {
      this.hidden = true
    },
    next() {
      if (this.currentQuestion === this.dialogObj.length - 1) {
        this.$emit('success')
        this.hide()
        // this.$router.push('/test')
        return
      }
      this.resetCards()
      this.currentQuestion += 1
      this.state = 'question'
    },
    runSuccess() {
      this.$store.commit('SET_RESULT', 5)
      this.dialog.obj.success = true
    },
    runError() {
      const cardMan = document.querySelector('.card[data-man]')
      const isLeft = cardMan.classList.contains('left')
      this.dialog.obj.success = false
      TweenMax
        .to('.card[data-man]', 0.3, {
          opacity: 1,
          scale: 1,
          rotation: '6deg',
          y: 0,
          x: isLeft ? '200%' : '100%',
        })
    },
  },
  mounted() {
    this.initDraggable()
  },
}
</script>
<style lang="scss" src="./Trainer.scss" module></style>
